import { useState } from 'react';

import { Box } from '@mui/material';
import { Card } from '@apigrowfinance/pbolt-card';
import { FormattedMessage } from 'react-intl';
import { useParams } from 'react-router-dom';

import AccountControlBodyDetails from '@components/controlDetails/account/AccountControlBodyDetails';
import AccountControlEditModal from '@components/controlDetails/account/AccountControlEditModal';
import ControlConditions from '@components/controlDetails/components/conditionsBlock/ControlConditions';
import ControlPageHeader from '@components/controlDetails/components/ControlPageHeader';
import FlexControlLimitBar from '@components/controlDetails/components/flexControlLimitBar/FlexControlLimitBar';
import LoadingErrorMessage from '@components/LoadingErrorMessage/LoadingErrorMessage';
import { useAccount } from '@contexts/AccountProvider';
import FlexControlType from '@enums/flexControls/type';
import useGetFlexControlAccount from '@hooks/queries/useGetFlexControlAccount';

const AccountControl = () => {
    const [showEditModal, setShowEditModal] = useState(false);
    const { account, isLoading: isLoadingAccounts } = useAccount();
    const { flexControlId } = useParams();

    const {
        data,
        isLoading: isLoadingFlexControlAccount,
        isError,
    } = useGetFlexControlAccount({
        accountId: `${account?.account_id}`,
        flexId: flexControlId,
    });

    const isLoading = isLoadingAccounts || isLoadingFlexControlAccount;
    const showGraph =
        !!data?.type && data?.type !== FlexControlType.RESTRICTION;

    if (isError) {
        return (
            <Card>
                <LoadingErrorMessage />
            </Card>
        );
    }

    return (
        <>
            <Box data-testid="heading-description">
                <FormattedMessage
                    id="CardControlAccountPageContainer.accountControls"
                    defaultMessage="Account controls"
                />
            </Box>
            <Card>
                <ControlPageHeader
                    data={data}
                    isActive={data?.active}
                    isLoading={isLoading}
                    setShowEditModal={setShowEditModal}
                />
            </Card>
            <Box height={2} />
            {showGraph && (
                <>
                    <Card isTopRadiusBorder={false} isIndented>
                        <FlexControlLimitBar flexControl={data} />
                    </Card>
                    <Box height={10} />
                </>
            )}
            <Card isTopRadiusBorder={false} isIndented>
                <AccountControlBodyDetails
                    cardControlItem={data}
                    isLoading={isLoading}
                    noOfColumnsPerRow={5}
                />
            </Card>

            <Box height={10} />
            <ControlConditions
                isLoading={isLoading}
                cardControlRules={data?.conditions}
                noColumnsPerRow={5}
            />
            <AccountControlEditModal
                cardControlItem={data}
                accountName={account?.social_name || ''}
                showEditModal={showEditModal}
                setShowEditModal={setShowEditModal}
            />
        </>
    );
};

export default AccountControl;
